import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import logo from "../../Assets/Images/logo.png";
import { Input, Badge, Button, AutoComplete,Modal } from "antd";
import {
  SearchOutlined,
  LogoutOutlined,
  LoginOutlined,
  UserOutlined,
  CloseOutlined,
  MenuOutlined,
} from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { cartSuccess } from "../../Redux/slices/cart";
import { logoutUser } from "../../Redux/slices/user";
import { wiseListSuccess } from "../../Redux/slices/wishList";
import API from "../../ApiService/ApiService";
import { base_url } from "../../config";
const { confirm } = Modal;

const Header7 = ({ home_custom , company, content_all}) => {
  let token = localStorage.getItem("token") || "";
  let login = localStorage.getItem("login") || false;
  let userData = localStorage.getItem("user") || null;
  const user = JSON.parse(localStorage.getItem("user")) || "";
// console.log("userData====>", company);
// console.log("content_allHeader7====>", content_all);
  const api = new API();

  const my_cart_details = useSelector((state)=>state.cart?.cart?.data);
  const my_wishList = useSelector((state)=>state?.wishList?.cart?.data);
  const dropdownRef = useRef(null);
  const [search, setSearch] = useState("");
  const [isSearchVisible, setIsSearchVisible] = useState(false);
  const [toggleVisible, setToggleVisible] = useState(false);
  const [menuToggleVisible, setMenuToggleVisible] = useState(false);
  const [cart, setCart] = useState([]);
  const [wiseList, setWiseList] = useState([]);
const [userLogin,setUserLogin]= useState("false")
  //  console.log("Top_Offer from componon", home_custom);

  const data4Checkout = {
    buyer_id: user?._id,
  };

  const dispatch = useDispatch();

  const navigate = useNavigate();

  const logout = () => {
    //data of the user will be deleted from local storage after logout and also set null value to userSlice
    dispatch(logoutUser(null));
    // dispatch(emptyRemoveAddress(null));
    // dispatch(emptyUpdateAddress(null));
    // dispatch(emptyUserAddress(null));
    // localStorage.setItem("user", "");
    // localStorage.setItem("token", "");
    // localStorage.setItem("login", false);
    localStorage.clear();
    navigate("/");
    window.location.reload();
  };

  useEffect(() => {
    getAllCart();
    getAllWiseList();
  }, []);

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const getAllCart = () => {
      // api
      //   .getcart()
      //   .then((res) => {
      //     setCart(res?.data?.data);
      //   })
      //   .catch((err) => {
      //     setCart([]);
      //   });

      if (user) {
        api.getcart(data4Checkout).then((res) => {
          // console.log("res--->", res);
          if (res.response?.data?.status === 500) {
            // message.error(res?.response?.data?.message);
            // navigate("/delivery-address");
            setCart({
              cart_item: [],
            });
          } else {
            setCart(res?.data?.data);
            dispatch(cartSuccess(res?.data));
          }
        });
      }
  };
  const getAllWiseList = () => {
      // api
      //   .getWishList()
      //   .then((res) => {
      //     setWiseList(res?.data?.data);
      //   })
      //   .catch((err) => {
      //     setWiseList([]);
      //   });

      
    api.getWishList(user?._id).then((res) => {
      setWiseList(res?.data?.data || []);
      dispatch(wiseListSuccess(res?.data));
    });
  };

  const Topoffercontent = home_custom?.top_offer;

  const toogleSearch = () => {
    setIsSearchVisible(!isSearchVisible);
  };

  const handleSearch = () => {
    if(search !== ""){
      navigate(`/products?product_name=${search}`);
      setIsSearchVisible(false);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  const toogleMobileMenu = () => {
    // console.log("toggleVisible", toggleVisible);
    // toggleVisible == true ? setToggleVisible(false) : setToggleVisible(true);
    if (toggleVisible == true) {
      setToggleVisible(false);
    } else {
      setToggleVisible(true);
    }
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setMenuToggleVisible(false);
    }
  };

  
  const showConfirm = () => {
    confirm({
      title: "Do you want to Confirm Logout ?",
      content: "Click 'OK' to Logout",
      async onOk() {
        logout();
      },
      onCancel() { },
    });
  };


  return (
    <Header_Align>
      <div className="wrapper" >
        <div className="header_Top_Section">
          <div
            className="top_text"
            dangerouslySetInnerHTML={{ __html: content_all?.smile_marquee }}
          ></div>
        </div>
        <div className="Header_Main" >
          <div className="Header_Left">
          <div className="Mobile_Menu" onClick={() => toogleMobileMenu()}>
                {toggleVisible ? (
                  <CloseOutlined style={{ fontSize: "24px", color: "#2f4076" }} />
                ) : (
                  <MenuOutlined style={{ fontSize: "24px", color: "#2f4076" }} />
                )}
              </div>
            <div className="logo" style={{ width: "150px"}}>
              <Link to="/">
                <img  style={{height:"50px"}} src={base_url + content_all?.smile_logo?.image} alt="logo" />
              </Link>
            </div>
          </div>
          <div className="Header_Middle">
            <div className="Search_bar">
                <Input
                  prefix={
                    <svg
                      onClick={handleSearch}
                      style={{ cursor: "pointer" }}
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clipPath="url(#clip0_4688_71)">
                        <path
                          d="M20.71 19.29L17.31 15.9C18.407 14.5025 19.0022 12.7767 19 11C19 9.41775 18.5308 7.87103 17.6518 6.55544C16.7727 5.23985 15.5233 4.21447 14.0615 3.60897C12.5997 3.00347 10.9911 2.84504 9.43928 3.15372C7.88743 3.4624 6.46197 4.22433 5.34315 5.34315C4.22433 6.46197 3.4624 7.88743 3.15372 9.43928C2.84504 10.9911 3.00347 12.5997 3.60897 14.0615C4.21447 15.5233 5.23985 16.7727 6.55544 17.6518C7.87103 18.5308 9.41775 19 11 19C12.7767 19.0022 14.5025 18.407 15.9 17.31L19.29 20.71C19.383 20.8037 19.4936 20.8781 19.6154 20.9289C19.7373 20.9797 19.868 21.0058 20 21.0058C20.132 21.0058 20.2627 20.9797 20.3846 20.9289C20.5064 20.8781 20.617 20.8037 20.71 20.71C20.8037 20.617 20.8781 20.5064 20.9289 20.3846C20.9797 20.2627 21.0058 20.132 21.0058 20C21.0058 19.868 20.9797 19.7373 20.9289 19.6154C20.8781 19.4936 20.8037 19.383 20.71 19.29ZM5 11C5 9.81332 5.3519 8.65328 6.01119 7.66658C6.67047 6.67989 7.60755 5.91085 8.7039 5.45673C9.80026 5.0026 11.0067 4.88378 12.1705 5.11529C13.3344 5.3468 14.4035 5.91825 15.2426 6.75736C16.0818 7.59648 16.6532 8.66558 16.8847 9.82946C17.1162 10.9933 16.9974 12.1997 16.5433 13.2961C16.0892 14.3925 15.3201 15.3295 14.3334 15.9888C13.3467 16.6481 12.1867 17 11 17C9.4087 17 7.88258 16.3679 6.75736 15.2426C5.63214 14.1174 5 12.5913 5 11Z"
                          fill="#0C356A"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_4688_71">
                          <rect width="24" height="24" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  }
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder="Product..."
                  onKeyDown={(e)=>{
                    if(e.key == "Enter"){
                      handleSearch()
                    }
                  }}
                />
            </div>
          </div>
          <div className="Header_Right">
            {login && token && userData ? (
              <div className="Icons">
                <Link to="/my-profile">
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M16 3C13.4288 3 10.9154 3.76244 8.77759 5.1909C6.63975 6.61935 4.97351 8.64968 3.98957 11.0251C3.00563 13.4006 2.74819 16.0144 3.2498 18.5362C3.75141 21.0579 4.98953 23.3743 6.80762 25.1924C8.6257 27.0105 10.9421 28.2486 13.4638 28.7502C15.9856 29.2518 18.5995 28.9944 20.9749 28.0104C23.3503 27.0265 25.3807 25.3603 26.8091 23.2224C28.2376 21.0846 29 18.5712 29 16C28.9964 12.5533 27.6256 9.24882 25.1884 6.81163C22.7512 4.37445 19.4467 3.00364 16 3ZM9.26001 24.6875C9.98342 23.5561 10.98 22.625 12.1579 21.9801C13.3358 21.3351 14.6571 20.9971 16 20.9971C17.3429 20.9971 18.6642 21.3351 19.8421 21.9801C21.02 22.625 22.0166 23.5561 22.74 24.6875C20.8129 26.1862 18.4413 26.9999 16 26.9999C13.5587 26.9999 11.1871 26.1862 9.26001 24.6875ZM12 15C12 14.2089 12.2346 13.4355 12.6741 12.7777C13.1137 12.1199 13.7384 11.6072 14.4693 11.3045C15.2002 11.0017 16.0044 10.9225 16.7804 11.0769C17.5563 11.2312 18.269 11.6122 18.8284 12.1716C19.3878 12.731 19.7688 13.4437 19.9231 14.2196C20.0775 14.9956 19.9983 15.7998 19.6955 16.5307C19.3928 17.2616 18.8801 17.8864 18.2223 18.3259C17.5645 18.7654 16.7911 19 16 19C14.9391 19 13.9217 18.5786 13.1716 17.8284C12.4214 17.0783 12 16.0609 12 15ZM24.22 23.3013C23.1047 21.6851 21.5365 20.4348 19.7125 19.7075C20.6923 18.9358 21.4072 17.878 21.7579 16.6811C22.1086 15.4843 22.0776 14.2079 21.6693 13.0294C21.2609 11.851 20.4955 10.8291 19.4794 10.1059C18.4634 9.38262 17.2472 8.99397 16 8.99397C14.7528 8.99397 13.5366 9.38262 12.5206 10.1059C11.5045 10.8291 10.7391 11.851 10.3307 13.0294C9.92238 14.2079 9.8914 15.4843 10.2421 16.6811C10.5928 17.878 11.3077 18.9358 12.2875 19.7075C10.4635 20.4348 8.89529 21.6851 7.78001 23.3013C6.37072 21.7165 5.4496 19.7581 5.12756 17.6619C4.80553 15.5657 5.09631 13.4211 5.9649 11.4864C6.83349 9.55163 8.24285 7.90922 10.0233 6.75692C11.8037 5.60462 13.8792 4.99156 16 4.99156C18.1208 4.99156 20.1963 5.60462 21.9768 6.75692C23.7572 7.90922 25.1665 9.55163 26.0351 11.4864C26.9037 13.4211 27.1945 15.5657 26.8724 17.6619C26.5504 19.7581 25.6293 21.7165 24.22 23.3013Z"
                      fill="#0C356A"
                    />
                  </svg>
                </Link>
                {/* <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M27 8.99998H22.615C22.6637 8.95872 22.7137 8.91873 22.7612 8.87498C23.1409 8.5377 23.4468 8.12571 23.66 7.66479C23.8731 7.20387 23.9889 6.70392 24 6.19623C24.0164 5.64082 23.9191 5.08791 23.7142 4.57146C23.5092 4.055 23.2008 3.58589 22.8079 3.19293C22.4151 2.79997 21.9461 2.49145 21.4297 2.2863C20.9133 2.08116 20.3604 1.98372 19.805 1.99998C19.2971 2.01091 18.7969 2.12658 18.3358 2.33973C17.8746 2.55289 17.4624 2.85894 17.125 3.23873C16.6581 3.77984 16.2785 4.39053 16 5.04873C15.7215 4.39053 15.3419 3.77984 14.875 3.23873C14.5376 2.85894 14.1254 2.55289 13.6642 2.33973C13.2031 2.12658 12.7029 2.01091 12.195 1.99998C11.6396 1.98372 11.0867 2.08116 10.5703 2.2863C10.0539 2.49145 9.58491 2.79997 9.19206 3.19293C8.79922 3.58589 8.49083 4.055 8.28584 4.57146C8.08085 5.08791 7.98358 5.64082 8 6.19623C8.01111 6.70392 8.12686 7.20387 8.34001 7.66479C8.55315 8.12571 8.85911 8.5377 9.23875 8.87498C9.28625 8.91623 9.33625 8.95623 9.385 8.99998H5C4.46957 8.99998 3.96086 9.21069 3.58579 9.58576C3.21071 9.96083 3 10.4695 3 11V15C3 15.5304 3.21071 16.0391 3.58579 16.4142C3.96086 16.7893 4.46957 17 5 17V25C5 25.5304 5.21071 26.0391 5.58579 26.4142C5.96086 26.7893 6.46957 27 7 27H25C25.5304 27 26.0391 26.7893 26.4142 26.4142C26.7893 26.0391 27 25.5304 27 25V17C27.5304 17 28.0391 16.7893 28.4142 16.4142C28.7893 16.0391 29 15.5304 29 15V11C29 10.4695 28.7893 9.96083 28.4142 9.58576C28.0391 9.21069 27.5304 8.99998 27 8.99998ZM18.625 4.56372C18.7833 4.38888 18.9761 4.24865 19.1912 4.15185C19.4063 4.05505 19.6391 4.00377 19.875 4.00122H19.9363C20.2127 4.00295 20.486 4.05984 20.7402 4.16856C20.9944 4.27728 21.2244 4.43565 21.4166 4.63437C21.6088 4.83309 21.7594 5.06818 21.8596 5.32586C21.9597 5.58353 22.0075 5.85861 22 6.13498C21.9975 6.37085 21.9462 6.60365 21.8494 6.81876C21.7526 7.03387 21.6123 7.22664 21.4375 7.38498C20.2512 8.43498 18.2825 8.80498 17.0625 8.93498C17.2125 7.61123 17.625 5.68747 18.625 4.56372ZM10.6138 4.60873C11.0012 4.22134 11.5259 4.00256 12.0737 3.99998H12.135C12.3709 4.00252 12.6037 4.0538 12.8188 4.1506C13.0339 4.2474 13.2267 4.38763 13.385 4.56248C14.4338 5.74748 14.8038 7.71247 14.9338 8.92747C13.7188 8.80247 11.7537 8.42747 10.5688 7.37873C10.3939 7.22039 10.2537 7.02762 10.1569 6.81251C10.0601 6.5974 10.0088 6.3646 10.0063 6.12873C9.9985 5.84777 10.0479 5.56817 10.1515 5.30688C10.255 5.04559 10.4106 4.80807 10.6088 4.60873H10.6138ZM5 11H15V15H5V11ZM7 17H15V25H7V17ZM25 25H17V17H25V25ZM27 15H17V11H27V15Z"
                  fill="#0C356A"
                />
              </svg> */}

                <Badge count={my_wishList?.length} offset={[0, 0]}>
                <Link to="/wish-list">
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M27.8748 7.12502C26.5162 5.76984 24.6763 5.00775 22.7574 5.00541C20.8385 5.00307 18.9967 5.76066 17.6348 7.11252L15.9998 8.63127L14.3636 7.10752C13.002 5.74978 11.1569 4.98852 9.23404 4.99122C7.3112 4.99391 5.46819 5.76034 4.11045 7.1219C2.75271 8.48345 1.99145 10.3286 1.99415 12.2514C1.99684 14.1743 2.76327 16.0173 4.12483 17.375L15.2936 28.7075C15.3866 28.802 15.4975 28.877 15.6199 28.9283C15.7422 28.9795 15.8735 29.0058 16.0061 29.0058C16.1387 29.0058 16.27 28.9795 16.3923 28.9283C16.5146 28.877 16.6255 28.802 16.7186 28.7075L27.8748 17.375C29.2335 16.0155 29.9968 14.1721 29.9968 12.25C29.9968 10.3279 29.2335 8.48454 27.8748 7.12502ZM26.4561 15.97L15.9998 26.575L5.53733 15.96C4.55271 14.9754 3.99956 13.64 3.99956 12.2475C3.99956 10.8551 4.55271 9.51964 5.53733 8.53502C6.52194 7.55041 7.85737 6.99725 9.24983 6.99725C10.6423 6.99725 11.9777 7.55041 12.9623 8.53502L12.9873 8.56002L15.3186 10.7288C15.5036 10.901 15.747 10.9967 15.9998 10.9967C16.2526 10.9967 16.496 10.901 16.6811 10.7288L19.0123 8.56002L19.0373 8.53502C20.0226 7.55107 21.3584 6.99882 22.7509 6.99975C24.1433 7.00069 25.4784 7.55474 26.4623 8.54002C27.4463 9.5253 27.9985 10.8611 27.9976 12.2536C27.9967 13.646 27.4426 14.9811 26.4573 15.965L26.4561 15.97Z"
                      fill="#0C356A"
                    />
                  </svg>
                </Link>
                  </Badge>
                <Badge count={my_cart_details?.cart_item?.length} offset={[0, 30]}>
                  <svg
                    onClick={() => navigate("/cart")}
                    className="cart_icon"
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M29.5005 8.675C29.3108 8.46212 29.0781 8.29189 28.8179 8.17554C28.5576 8.05918 28.2756 7.99935 27.9905 8H22.0005C22.0005 6.4087 21.3683 4.88258 20.2431 3.75736C19.1179 2.63214 17.5918 2 16.0005 2C14.4092 2 12.883 2.63214 11.7578 3.75736C10.6326 4.88258 10.0005 6.4087 10.0005 8H4.01046C3.72703 8.00076 3.44696 8.06127 3.18849 8.17758C2.93003 8.29389 2.699 8.46338 2.51046 8.675C2.32349 8.88583 2.18319 9.1338 2.09875 9.40264C2.01431 9.67148 1.98763 9.95513 2.02046 10.235L3.80296 25.235C3.86077 25.7237 4.09675 26.174 4.46574 26.4996C4.83474 26.8253 5.31084 27.0034 5.80296 27H26.2092C26.7013 27.0034 27.1774 26.8253 27.5464 26.4996C27.9154 26.174 28.1514 25.7237 28.2092 25.235L29.9917 10.235C30.0244 9.95504 29.9975 9.67134 29.9128 9.40249C29.8282 9.13364 29.6876 8.88573 29.5005 8.675ZM16.0005 4C17.0613 4 18.0787 4.42143 18.8289 5.17157C19.579 5.92172 20.0005 6.93913 20.0005 8H12.0005C12.0005 6.93913 12.4219 5.92172 13.172 5.17157C13.9222 4.42143 14.9396 4 16.0005 4ZM26.2205 25C26.2168 25.0013 26.2128 25.0013 26.2092 25H5.78171L4.01046 10H10.0005V13C10.0005 13.2652 10.1058 13.5196 10.2934 13.7071C10.4809 13.8946 10.7352 14 11.0005 14C11.2657 14 11.52 13.8946 11.7076 13.7071C11.8951 13.5196 12.0005 13.2652 12.0005 13V10H20.0005V13C20.0005 13.2652 20.1058 13.5196 20.2934 13.7071C20.4809 13.8946 20.7352 14 21.0005 14C21.2657 14 21.52 13.8946 21.7076 13.7071C21.8951 13.5196 22.0005 13.2652 22.0005 13V10H28.0005L26.2205 25Z"
                      fill="#0C356A"
                    />
                  </svg>
                </Badge>
                <Button  onClick={showConfirm}>Logout</Button>
              </div>
            ) : (
              <Link to="/login" style={{ textDecoration: "none" }}>
                <Button style={{ display: "flex", alignItems: "center" }} >
                  <LoginOutlined /> Login
                </Button>
              </Link>
            )}
          </div>
          <div
            className="menu_for_mobile"
            style={{ backgroundColor: "white" }}
            hidden={!toggleVisible}
          >
            <ul>                                    
              <Link
                to="/my-profile"
                style={{ textDecoration: "none", color: "#2f4076" }}
              >
                {login && token && userData ? (
                  <li onClick={() => setToggleVisible(!toggleVisible)}>
                    My Profile
                  </li>
                ) : null}
              </Link>

              <Link
                to="/wish-list"
                style={{ textDecoration: "none", color: "#2f4076" }}
              >
                {login && token && userData ? (
                  <li onClick={() => setToggleVisible(!toggleVisible)}>
                    Wishlist
                  </li>
                ) : null}
              </Link>
              <Link
                to="/cart"
                style={{ textDecoration: "none", color: "#2f4076" }}
              >
                {login && token && userData ? (
                  <li onClick={() => setToggleVisible(!toggleVisible)}>Cart</li>
                ) : null}
              </Link>
              {login && token && userData ? (
                <li>
                  <div
                    className="Login_Logout"
                    onClick={() => logout(true)}
                    style={{ color: "#2f4076" }}
                  >
                    Logout
                  </div>
                </li>
              ) : (
                <li onClick={() => setToggleVisible(!toggleVisible)}>
                  <div className="Login_Logout">
                    <Link
                      to="/login"
                      style={{ textDecoration: "none", color: "#2f4076" }}
                    >
                      Login
                    </Link>
                  </div>
                </li>
              )}
            </ul>
          </div>
        </div>
      </div>
    </Header_Align>
  );
};

export default Header7;

const Header_Align = styled.div`
  padding: 0 !important;
  .wrapper {
    /* max-width: 2000px; */
    padding: 0 !important;
  }

  .header_Top_Section {
    height: 30px;
    background: #fff0ce;
    text-align: center;
    /* margin-bottom: 1%; */
  }

  .cart_icon {
    cursor: pointer;
  }

  .top_text {
    color: #000;
    /* font-family: Poppins; */
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    padding: 5px 0;
  }

  .top_text span {
    color: #0174be;
    /* font-family: Poppins; */
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }

  .Mobile_Menu{
    display: none;
  }

  .menu_for_mobile {
    display: none;
    background-color: #fff; /* Set your preferred background color */
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); /* Add a subtle box shadow */
    border-radius: 8px; /* Add rounded corners */
    position: absolute;
    top: 70px;
    left: 0;
    width: 100%;
    z-index: 1000;
  }

  .menu_for_mobile ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .menu_for_mobile ul li {
    padding: 15px;
    border-bottom: 1px solid #e6e6e6; /* Add a border between menu items */
    /* text-align: center; */
    color: #2f4076;
  }

  .menu_for_mobile ul li:last-child {
    border-bottom: none; /* Remove border for the last menu item */
  }

  .nav_links {
    position: absolute;
    border: 1px solid #2f4076;
    background-color: #fff;
    border-radius: 5px;
    padding-left: 0px;

    :hover {
      background-color: #f7f7f7;       
    }
  }

  .nav_links li {
    color: #2f4076;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 15px;
    padding-right: 15px;
    font-size: 16px !important;
/* 
    :hover {
      color: #f75d81 !important;      
    } */
  }

  .Header_Main {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    /* padding-top: 15px; */
    background-color: #fff;
  }

  .Header_Main .Header_Left .logo {
    width: 100px;
    height: 56px;
    flex-shrink: 0;
  }

  .Header_Middle .Search_bar {
    width: 628px;
    height: 68px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .auto_complete{
    width: 100%;
  }

  Input {
    padding: 8px !important;
    border: 1px solid #0c356a;
    background: #f9f9f9;
  }

  .ant-input-prefix {
    background: #ffc300;
    display: flex;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 8px;
    left: auto;
    right: 10px;
    z-index: 1;
  }

  .search_icon {
    color: #0c356a;
    font-size: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .Header_Right .Icons {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
  }

  .ant-badge .ant-scroll-number {
    background: #0c356a;
  }

  :where(.css-dev-only-do-not-override-14wwjjs).ant-input-affix-wrapper {
    position: relative;
    display: inline-flex;
    width: 100%;
    min-width: 0;
    /* padding: 4px 11px; */
    color: rgba(0, 0, 0, 0.88);
    font-size: 14px;
    line-height: 1.5714285714285714;
    background-color: #ffffff;
    background-image: none;
    border-width: 1px;
    border-style: solid;
    border-color: #d9d9d9;
    border-radius: 6px;
    transition: all 0.2s;
  }

  @media screen and (min-width: 992px) and (max-width: 1024px) {
    .Header_Middle .Search_bar {
      width: 400px;
      height: 68px;
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  } 

  @media screen and (min-width: 769px) and (max-width: 991px) {
    .Header_Middle .Search_bar {
      width: 308px;
      height: 68px;
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }

    /* .Mobile_Menu{
      display: block;
    } */

    .Header_Left{
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 20%;
    }

    .Header_Right {
      display: none;
    }
  }

  @media screen and (min-width: 700px) and (max-width: 768px) {
    /* .Header_Main .Header_Middle {
      display: none;
    } */

      .Header_Left{
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 20%;
    }

    .Header_Middle .Search_bar {
      width: 250px;
      height: 68px;
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }

  @media screen and (min-width: 540px) and (max-width: 700px) {
    .Header_Main .Header_Middle {
      display: none;
    }

      .Header_Left{
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 20%;
    }   
  }

  @media screen and (min-width: 425px) and (max-width: 539px) {
    .Header_Main .Header_Middle {
      display: none;
    }

    .Header_Right {
      display: none;
    }

    .Mobile_Menu{
    display: block;
    }

    .menu_for_mobile {
      display: block;
      position: absolute;
      top: 90px;
      left: 0;
    }

      .Header_Left{
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 90%;
    }   

    .Header_Left .logo {    
    width: 90px !important;
  }
  }

  @media screen and (min-width: 375px) and (max-width: 424px) {
    .Header_Main .Header_Middle {
      display: none;
    }

    .Header_Right {
      display: none;
    }

    .Mobile_Menu{
      display: block;
    }

    .menu_for_mobile {
      display: block;
      position: absolute;
      top: 90px;
      left: 0;
    }

    .Header_Left{
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 90%;
    }   

    .Header_Left .logo {    
      width: 90px !important;
    }
  }

  @media screen and (min-width: 320px) and (max-width: 374px) {
    .Header_Main .Header_Middle {
      display: none;
    }

    .Header_Right {
      display: none;
    }

    .Mobile_Menu{
      display: block;
    }

    .menu_for_mobile {
      display: block;
      position: absolute;
      top: 90px;
      left: 0;
    }

    .Header_Left{
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 90%;
    }   

    .Header_Left .logo {    
      width: 90px !important;
    }
  }

  @media screen and (min-width: 280px) and (max-width: 319px) {
    .Header_Main .Header_Middle {
      display: none;
    }

    .Header_Right {
      display: none;
    }

    .Mobile_Menu{
      display: block;
    }

    .menu_for_mobile {
      display: block;
      position: absolute;
      top: 90px;
      left: 0;
    }

    .Header_Left{
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 90%;
    }   

    .Header_Left .logo {    
      width: 90px !important;
    }
  }
`;
